import styled from 'styled-components'

import { SizeSelector } from '@Components/SizeSelector'
import { up } from '@Globals/Style/breakpoints'
import { box, modalFooter, modalMessage } from '@Globals/Style/mixins'

export const Container = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.greyLightest,
  borderRadius: theme.borderRadius,
  marginTop: 20,
  padding: '10px 10px 0',
  width: '100%',

  p: {

    '&.title': {
      fontSize: '1.25rem',
      fontWeight: 700,
      textTransform: 'uppercase',
    },
  },

  '.buttonWrap': {
    display: 'flex',
    width: '100%',
  },
}))

export const Message = styled.div`
  ${modalMessage}
`

export const Footer = styled.div`
  ${modalFooter}
`

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .modalTitle {
    width: 100%;
    margin-bottom: 10px;
    text-align: center;
    font-size: 1.5rem;
  }

  .productTitle {
    padding-bottom: 25px;
  }
`

export const ProductImage = styled.div`
  ${box({ width: '90px' })}
  margin-bottom: 15px;
`

export const SelectorAndBuyButtonWrapper = styled.section(({ theme }) => ({
  '> *': {
    flex: '1 0 50%',
    // There's some weird specificity stuff going on in production with this being overridden,
    // so we need to make it important. It doesn't happen in development. ¯\_(ツ)_/¯
    margin: '0 !important',
  },

  '.buy-button': {
    borderRadius: `0 ${theme.borderRadius} ${theme.borderRadius} 0`,
    fontSize: '.875rem',
    minHeight: 46,

    [up('tablet')]: {
      fontSize: 'inherit',
    },
  },

  alignItems: 'stretch',
  display: 'flex',
  marginBottom: 10,
  minHeight: 46,
  width: '100%',
}))

export const StyledSizeSelector = styled(SizeSelector)(({ theme }) => ({
  select: {
    borderRadius: `${theme.borderRadius} 0 0 ${theme.borderRadius} !important`,
    fontSize: '.875rem',
    height: '100% !important',

    [up('tablet')]: {
      fontSize: 15,
    },

    '&:hover, &:focus': {
      background: theme.colors.greyLightestest,
    },
  },
}))
